var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FormSection"},[_c('SectionHeadline',{attrs:{"text":_vm.title,"extraText":_vm.extraText}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }